/**
 * Admin users by email. Eventually replace with admin role from fetch-scope API.
 */
export const ADMIN_EMAILS: string[] = [
    'vijay.shankar@asper.ai',
    'praveen.s2@asper.ai',
    'suman.kumar@asper.ai',
    'raghav.dhir@asper.ai',
    // 'admin2@asper.ai',
    // 'admin3@asper.ai',
    // 'admin4@asper.ai',
    // 'admin5@asper.ai',
];

export function isAdminUser(): boolean {
    const email = typeof localStorage !== 'undefined' ? localStorage.getItem('email') : null;
    return !!email && ADMIN_EMAILS.includes(email);
}
